<script lang="ts">
    import { cn, type WithElementRef } from "../../../utils.js";
    import type { HTMLAttributes } from "svelte/elements";
    import type { Snippet } from "svelte";

    let {
        ref = $bindable(null),
        class: className,
        child,
        ...restProps
    }: WithElementRef<HTMLAttributes<HTMLDivElement>> & {
        child?: Snippet<[{ props: Record<string, unknown> }]>;
    } = $props();

    const mergedProps = $derived({
        ...restProps,
        class: cn(
            "bg-muted shadow-xs flex items-center gap-2 rounded-md border px-4 text-sm font-medium [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none",
            className,
        ),
    });
</script>

{#if child}
    {@render child({ props: mergedProps })}
{:else}
    <div bind:this={ref} {...mergedProps}>
        {@render mergedProps.children?.()}
    </div>
{/if}
